export default __webpack_public_path__ + "static/media/Group 4947@2x.211f5841.png";